import { createRequestTypes } from 'common/websocket-redux';

export const GET_USER_OPTIMUM_PROFILE = createRequestTypes(
  'employer-experience/user-optimum-profile/GET_USER_OPTIMUM_PROFILE',
);

export const getUserOptimumProfile = userId =>
  GET_USER_OPTIMUM_PROFILE.request({ userId });
